import React from 'react';
import { ArrowLeft, MapPin } from 'lucide-react';

const AddressForm = ({ 
  addressForm, 
  handleAddressChange, 
  handleAddressSubmit, 
  handleBackToCart,
  isEditing = false,
  onOpenLocationPicker // 👉 NEW PROP (opens Map Picker)
  
}) => {
  return (
    <div className="address-form-section">
      <div className="form-header">
        <button 
          className="back-button-text"
          onClick={handleBackToCart}
        >
          <ArrowLeft size={20} />
          Back
        </button>
        <h2 className="form-title">
          {isEditing ? 'Edit Address' : 'Add New Address'}
        </h2>
      </div>

      <form className="address-form" onSubmit={handleAddressSubmit}>
        <div className="form-grid">
          <div className="form-group">
            <label className="form-label">Full Name *</label>
            <input 
              type="text" 
              className="form-input" 
              name="fullName"
              value={addressForm.fullName}
              onChange={handleAddressChange}
              placeholder="Enter your full name"
              required 
            />
          </div>

          <div className="form-group">
            <label className="form-label">Contact Number *</label>
            <input 
              type="tel" 
              className="form-input" 
              name="contactNumber"
              value={addressForm.contactNumber}
              onChange={handleAddressChange}
              placeholder="Enter your phone number"
              required 
            />
          </div>

          <div className="form-group">
            <label className="form-label">Email Address *</label>
            <input 
              type="email" 
              className="form-input" 
              name="email"
              value={addressForm.email}
              onChange={handleAddressChange}
              placeholder="Enter your email"
              required 
            />
          </div>

          <div className="form-group full-width">
            <label className="form-label">Full Address *</label>
            <textarea 
              className="form-input form-textarea" 
              name="address"
              value={addressForm.address}
              onChange={handleAddressChange}
              placeholder="Enter your complete address"
              rows="3"
              required
            ></textarea>
          </div>

          <div className="form-group">
            <label className="form-label">Pincode *</label>
            <input 
              type="text" 
              className="form-input" 
              name="pincode"
              value={addressForm.pincode}
              onChange={handleAddressChange}
              placeholder="Enter pincode"
              required 
            />
          </div>

          <div className="form-group">
            <label className="form-label">State *</label>
            <input 
              type="text" 
              className="form-input" 
              name="state"
              value={addressForm.state}
              onChange={handleAddressChange}
              placeholder="Enter state"
              required 
            />
          </div>

          <div className="form-group full-width">
            <label className="form-label">Landmark (Optional)</label>
            <input 
              type="text" 
              className="form-input" 
              name="landmark"
              value={addressForm.landmark}
              onChange={handleAddressChange}
              placeholder="Enter nearby landmark"
            />
          </div>

          {/* 🔥 LOCATION SECTION */}
          <div className="form-group full-width">
            <label className="form-label">Delivery Location on Map *</label>

            <button 
              type="button" 
              className="primary-button"
              onClick={onOpenLocationPicker}  // 👉 opens Map picker
            >
              <MapPin size={18} />
              {addressForm.latitude && addressForm.longitude 
                ? 'Change Location on Map' 
                : 'Set Location on Map'}
            </button>

            {/* 👇 Show Lat/Lng when selected */}
            {addressForm.latitude && addressForm.longitude && (
              <p className="coords-text">
                📍 Lat: {Number(addressForm.latitude).toFixed(6)} | 
                Lng: {Number(addressForm.longitude).toFixed(6)}
              </p>
            )}
          </div>
        </div>
        
        <div className="form-actions">
          <button 
            type="button" 
            className="secondary-button"
            onClick={handleBackToCart}
          >
            Cancel
          </button>

          <button type="submit" className="primary-button">
            {isEditing ? 'Update Address' : 'Save Address'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddressForm;
